import { render, staticRenderFns } from "./gift_content_view.vue?vue&type=template&id=d2a3f04a"
import script from "./gift_content_view.vue?vue&type=script&lang=js"
export * from "./gift_content_view.vue?vue&type=script&lang=js"
import style0 from "./gift_content_view.vue?vue&type=style&index=0&id=d2a3f04a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports